// import "server-only";

export const token =
  'sk01zQ4vdZkbPatD0f6j6mL4svNI4m4fG8wuzq0JYqKeorPYpFSOzTzkFXN7XxbrGNFYwT0zQRdWRSBfjq3wBy9Zv3AlT6X7LOn8JGqbQArNaGo2MmbTdeKVeYqCf2NamKqzmpZKFcGceUdEfGZuXTetSNsIsQSc6bdOTfXGhCVuWNH16EHD';

if (!token) {
  throw new Error('Missing SANITY_API_READ_TOKEN');
}
